<template>
    <div>
        <div class="container-block" style="margin:15px 0;">
            <a-form-model layout="inline">
                <a-form-model-item label="产品">
                    <a-input style="width:200px" placeholder="产品" @pressEnter="getList()"
                        v-model="search.materialKeyword" />
                </a-form-model-item>
                <a-form-model-item label="配方">
                    <a-input style="width:200px" placeholder="配方" @pressEnter="getList()"
                        v-model="search.formulaKeyword" />
                </a-form-model-item>
                <a-form-model-item label="期间">
                    <a-input style="width:200px" placeholder="期间" @pressEnter="getList()" v-model="search.rangeName" />
                </a-form-model-item>
<!--                <a-form-model-item label="是否推送">-->
<!--                    <a-select v-model="search.isPush" style="width: 200px;" placeholder="请选择">-->
<!--                        <a-select-option :value="1">是</a-select-option>-->
<!--                        <a-select-option :value="0">否</a-select-option>-->
<!--                    </a-select>-->
<!--                </a-form-model-item>-->
                <a-form-model-item label="生成日期">
                    <a-range-picker valueFormat="YYYY-MM-DD" v-model="search.createTime" />
                </a-form-model-item>
                <a-form-model-item>
                    <a-space>
                        <a-button type="primary" @click="getList()">查询</a-button>
                        <a-button @click="resetList">清空</a-button>
                    </a-space>
                </a-form-model-item>
            </a-form-model>
        </div>
        <div class="container-block" style="padding-bottom:0">
            <a-table :columns="columns" :loading="tableLoading" :data-source="list.records"
                :row-key="record => record.id" :pagination="pagination" @change="onTableChange">
                <span slot="isPush" slot-scope="text" :style="{ color: text == 0 ? 'red' : 'green' }">
                    {{ text == 0 ? '否' : '是' }}
                </span>
                <span slot="testFormulaType" slot-scope="text">
                    {{ text == '1' ? '测算配方' : '执行配方' }}
                </span>
                <template slot="options" slot-scope="text, record">
                    <a @click="viewDetail(record)">查看</a>
                </template>
            </a-table>
        </div>

        <calc-detail :visible="detailModalVisible" :formulaObj="detailModalFormula"
            @close="detailModalVisible = false"></calc-detail>
    </div>
</template>

<script>
import CalcDetail from './modal/CalcDetail.vue';
import { tableMixins } from '@/Utils/tableMixins.js';
const columns = [
    {
        title: '期间',
        dataIndex: 'rangeName',
        align: 'center',
        ellipsis: true,
    },
    {
        title: '五日测算版本号',
        dataIndex: 'pushVersion',
        align: 'center',
        ellipsis: true,
        width: 200
    },
    {
        title: '产品名称',
        dataIndex: 'materialName',
        align: 'center',
        ellipsis: true,
    },
    {
        title: '产品编码',
        dataIndex: 'materialCode',
        align: 'center',
        ellipsis: true,
    },
    {
        title: '配方名称',
        dataIndex: 'formulaName',
        align: 'center',
        ellipsis: true,
    },
    {
        title: '配方代码',
        dataIndex: 'formulaCode',
        align: 'center',
        ellipsis: true,
    },
    {
        title: '版本',
        dataIndex: 'productVersion',
        align: 'center',
        ellipsis: true,
    },
    {
        title: '类型',
        dataIndex: 'testFormulaType',
        align: 'center',
        ellipsis: true,
        scopedSlots: { customRender: 'testFormulaType' }
    },
    // {
    //     title: '是否推送',
    //     dataIndex: 'isPush',
    //     align: 'center',
    //     scopedSlots: { customRender: 'isPush' }
    // },
    // {
    //     title: '推送时间',
    //     dataIndex: 'pushTime',
    //     align: 'center',
    //     ellipsis: true,
    // },
    {
        title: '生成时间',
        align: 'center',
        dataIndex: 'createTime',
        ellipsis: true,
    },
    {
        title: '操作',
        dataIndex: 'options',
        width: 180,
        align: 'center',
        scopedSlots: { customRender: 'options' }
    },
];

export default {
    components: { CalcDetail },
    mixins: [tableMixins],
    data() {
        return {
            columns,
            tableLoading: false,
            list: {
                records: []
            },
            search: {},

            detailModalFormula: {},
            detailModalVisible: false
        };
    },
    mounted() {
        this.getList();
    },
    watch: {
        '$route'() {
            this.getList();
        },
    },
    computed: {

    },
    methods: {
        async getList(pagination) {
            let { current, pageSize } = pagination || this.pagination;
            let data = {
                factoryId: this.factoryId,
                staffId: this.staffId,
                query: {
                    current: current,
                    size: pageSize
                },
                ...this.search
            };
            if (this.search.createTime) {
                const [start, end] = this.search.createTime;
                data = { ...data, createTimeStart: `${start} 00:00:00`, createTimeEnd: `${end} 23:59:59` };
            }

            await this.$http.post("/nhf-app/fridaycalculatemonthplanformula/pageFridayCalculateMonthPlanFormulaVO", data).then(res => {
                let { data, success, msg } = res || {};
                if (success) {
                    let { records, total = 0, current = 1, size } = data || {};
                    this.list.records = records;
                    this.setPagination({ total, current, size });
                } else {
                    this.$message.error(msg);
                }
            });
        },

        resetList() {
            this.search = {};
            this.getList();
        },

        onTableChange(pagination) {
            this.getList(pagination);
        },

        viewDetail(row) {
            this.detailModalFormula = row;
            this.detailModalVisible = true;
        }
    }
};
</script>
<style scoped>
.disabled {
    color: #888;
}

.list-item {
    font-size: 12px;
}

.dropdown-list {
    max-height: 300px;
    width: 240px;
    overflow: auto;
    margin: -10px;
}
</style>
